module.exports = __webpack_public_path__ + "img/money.815d9dca.svg";